module.exports = __WEBPACK_EXTERNAL_MODULE__ux_quantity_selector__;